// ABAC module taxonomy + professional designations and onboarding presets.
// Keep MODULE keys in sync with backend enforcement.py / models_pro.py.

export const MODULES = [
  { key: "overview", label: "Overview", route: "/dashboard" },
  { key: "portfolio", label: "Portfolio", route: "/holdings" },
  { key: "ownership", label: "Ownership", route: "/ownership" },
  { key: "private_capital", label: "Private Capital", route: "/alternatives" },
  { key: "fixed_income", label: "Fixed Income", route: "/fixed-income" },
  { key: "entities", label: "Entities & Family", route: "/entities" },
  { key: "corporate", label: "Corporate", route: "/corporate" },
  { key: "documents", label: "Document Vault", route: "/documents" },
  { key: "compliance", label: "Compliance", route: "/compliance" },
  { key: "governance", label: "Governance", route: "/governance" },
  { key: "reports", label: "Reports", route: "/reports" },
];

export const MODULE_LABEL = MODULES.reduce((a, m) => ({ ...a, [m.key]: m.label }), {});

export const DESIGNATIONS = [
  "Chartered Accountant (CA)",
  "Cost & Management Accountant (CMA/ICWA)",
  "Company Secretary (CS)",
  "Accountant",
  "Bookkeeper",
  "Auditor",
  "Tax Advisor",
  "Legal Counsel",
];

export const MEMBERSHIP_BODIES = ["ICAI", "ICSI", "ICMAI (ICWAI)", "Bar Council", "Other"];

// Suggested module access presets per designation (admin can override)
export const DESIGNATION_PRESETS = {
  "Chartered Accountant (CA)": { overview: "view", entities: "view", corporate: "edit", compliance: "edit", documents: "edit", reports: "view" },
  "Cost & Management Accountant (CMA/ICWA)": { overview: "view", corporate: "view", compliance: "edit", documents: "edit", reports: "view" },
  "Company Secretary (CS)": { overview: "view", entities: "view", corporate: "edit", compliance: "edit", governance: "edit", documents: "edit" },
  "Accountant": { overview: "view", portfolio: "edit", corporate: "edit", documents: "edit" },
  "Bookkeeper": { corporate: "edit", documents: "edit" },
  "Auditor": { overview: "view", portfolio: "view", corporate: "view", compliance: "view", documents: "view", reports: "view" },
  "Tax Advisor": { overview: "view", compliance: "edit", documents: "view", reports: "view" },
  "Legal Counsel": { entities: "view", corporate: "view", governance: "edit", documents: "edit" },
};

export const MEMBERSHIP_FOR_DESIGNATION = {
  "Chartered Accountant (CA)": "ICAI",
  "Company Secretary (CS)": "ICSI",
  "Cost & Management Accountant (CMA/ICWA)": "ICMAI (ICWAI)",
  "Legal Counsel": "Bar Council",
};

// ---- helpers ----
export const isProfessional = (user) =>
  user?.user_type === "professional" ||
  (user?.module_access && Object.keys(user.module_access).length > 0);

export const canAccessModule = (user, key) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (!isProfessional(user)) return true; // principals (editor/viewer) keep full nav
  return !!(user.module_access && user.module_access[key]);
};

export const allowedModules = (user) => MODULES.filter((m) => canAccessModule(user, m.key));

export const routeModuleKey = (path) => {
  const m = MODULES.find((x) => path.startsWith(x.route));
  return m ? m.key : null;
};

export const engagementStatus = (p) => {
  if (!p?.active) return "inactive";
  const today = new Date().toISOString().slice(0, 10);
  if (p.valid_until && String(p.valid_until).slice(0, 10) < today) return "expired";
  if (p.valid_from && String(p.valid_from).slice(0, 10) > today) return "pending";
  return "active";
};
